import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { RestService, ApiQueryParams } from './lib/RestService';
import { setQueryParams } from './lib/helpers';
import { BreadCrumb } from './breadcrumbs.service';

export class SearchResult {
  ID: string;
  ITEM_ID: string;
  TITLE: string;
  TITLE_FORMATED: string;
  TITLE_FORMATED_TYPE: string;
  BODY: string;
  BODY_FORMATED: string;
  BODY_FORMATED_TYPE: string;
  PARAM1: string;
  PARAM2: string;
  UPD: Date;
  DATE_FROM: Date;
  DATE_TO: Date;
  FULL_DATE_CHANGE: Date;
  DATE_CHANGE: Date;
  TAGS: string;
  TAGS_FORMATED: object;
  CRUMBS?: BreadCrumb[];
}

@Injectable()
export class SearchService extends RestService {
  private apiUrl = `${environment.apiUrl}shop/Search/`;

  constructor(private http: HttpClient) {
    super();
  }

  search(params: ApiQueryParams): Promise<SearchResult[] | any> {
    const apiUrl = setQueryParams(this.apiUrl, params);
    return this.http.get<any[]>(apiUrl)
      .toPromise()
      .catch(this.handleError);
  }

  public getCount(params: ApiQueryParams): Promise<{count: number} | any> {
    const apiUrl = setQueryParams(`${this.apiUrl}count`, params);
    return this.http.get<{count: number}>(apiUrl)
      .toPromise()
      .catch(this.handleError);
  }
}
